import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardTitle } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsFormat from 'date-fns/format';
import addDays from 'date-fns/addDays';
import TransactionHistory from './TransactionHistory';

const Transactions = (props) => {
  const { warehouseId } = useParams();
  const [selectDate, setSelectDate] = useState(addDays(new Date(), -90));

  useEffect(() => {
    props.fetchWarehouseTransactionsFromDate(
      warehouseId,
      DateFnsFormat(addDays(new Date(), -90), 'yyyy-MM-dd'),
      'all'
    );
  }, [warehouseId]);

  const handleToChange = (date) => {
    setSelectDate(date);
  };

  const doit = () => {
    props.reconcileWarehouseUpto(warehouseId, DateFnsFormat(selectDate, 'yyyy-MM-dd'));
  };

  if (props.transactions.isFetching) {
    return (
      <Card>
        <Card.Header>{warehouseId} Transactions</Card.Header>
        <div className="loader">Loading...</div>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Header>
        <CardTitle>{warehouseId} Transactions</CardTitle>
      </Card.Header>
      <Card.Body>
        <TransactionHistory
          hidden={false}
          transactions={props.transactions}
          deleteTransaction={props.deleteTransaction}
          reconcileSingle={props.reconcileSingle}
          unreconcileTransaction={props.unreconcile}
          id={warehouseId}
          fetchTransactionsBetweenDates={props.fetchWarehouseTransactionsBetweenDates}
        />

        <div>
          <h4>Reconcile all transactions up to date</h4>
          <p>Select from:</p>
          <DatePicker
            selected={selectDate}
            onChange={handleToChange}
            dateFormat="dd-MM-yyyy"
          />
          <button onClick={doit} className="btn btn-primary mt-2">
            Do It
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Transactions;